import ListItem from "./listItem";
import { DatabaseValue } from "../../../contexts/database";
import { useContext } from "react";

export default function Tables({ open, active, onClick }) {
  const tables = useContext(DatabaseValue);

  if (!open) return null;
  return (
    <div>
      {(tables || []).map((table, i) => (
        <ListItem
          key={table.id}
          index={i}
          title={table.name}
          active={active === i}
          onClick={onClick}
        />
      ))}
    </div>
  )
}
